module.exports = __webpack_public_path__ + "img/faux-carousel-blocks@2x.413d7c5d.png";